import css from "./side_panel_footer.module.scss";

export const DefaultFooter = () => <div className={css.defaultFooter} />;
